import { Text } from '@mantine/core';
import { useProfile } from 'init/use-enforce-profile';
import { i18nKeys, useTranslation } from 'locales';
import { TenantCards } from './TenantCards';

export const GroupOverview = () => {
  const { t } = useTranslation();
  const { accessibleTenants, group } = useProfile();

  const reachableGroupCompanyCount = accessibleTenants.filter(
    tenant => tenant.groupId === group?.id,
  ).length;

  return (
    <>
      {group && (
        <Text c="gray.6" mb="md">
          {t(i18nKeys.GROUP.COMPANIES_REACHED, {
            count: reachableGroupCompanyCount,
            total: group.companiesCount,
          })}
        </Text>
      )}

      <TenantCards tenants={accessibleTenants} />
    </>
  );
};
